import generatedContent from '@/generated/content-index.json'
import {
  noteFrontmatterSchema,
  type CaseStudy,
  type Note,
  type Post,
} from '@/domain/content'
import { longCaseStudyFrontmatterSchema, type CaseStudyLong } from '@/domain/longCaseStudy'
import { getCaseStudySlug } from '@/lib/caseStudySlug'
import type { ContentSource } from './contentSource'

type GeneratedContentPayload = {
  notes: Array<Record<string, unknown>>
  caseStudies: Array<Record<string, unknown>>
}

const contentPayload = generatedContent as GeneratedContentPayload

const notes = contentPayload.notes.map((item) => {
  const parsed = noteFrontmatterSchema.parse(item)
  return { ...parsed, type: 'note', content: String(item.content ?? '') } as Note
})

const parseCaseStudy = (item: Record<string, unknown>): CaseStudy => {
  const content = String(item.content ?? '')
  const parsed = longCaseStudyFrontmatterSchema.parse(item)
  return { ...parsed, content } as CaseStudyLong
}

const caseStudies = contentPayload.caseStudies.map(parseCaseStudy)

export const filesystemSource: ContentSource = {
  getAllNotes: () => notes,
  getAllCaseStudies: () => caseStudies,
  getContentBySlug: (type: Post['type'], slug: string) => {
    if (type === 'note') {
      return notes.find((item) => item.slug === slug)
    }

    return caseStudies.find((item) => getCaseStudySlug(item) === slug)
  },
}
